import React from "react";
import { Link } from "react-router-dom";
import "../components/ErrorPages.css";

const NotFound = () => {
  return (
    <div className="notfound-body center-section text-center">
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6">
        {/* Left Content */}
        <div className="content">
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>
            Oops! The page you are looking for doesn’t exist or has been moved.
            Let’s get you back on track with CodeInputs.
          </p>

          <div className="buttons">
            <Link to="/" className="btn btn-primary me-3">Go to Home</Link>
            <Link to="/contact" className="btn btn-outline">Contact Us</Link>
          </div>
        </div>
      </div>

        {/* Right Illustration */}
      <div className="col-md-6">
        <div className="illustration">
          {/* You can replace this with SVG component also */}
          <img className="responsive-img"
            src="/graphics/images/404illustration.svg"
            alt="Not Found Error"
          />
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default NotFound;
